module.exports = __webpack_public_path__ + "assets/44f39dada53b5adef8622cf4830c489f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WildLandL.mp3
 ** module id = 384
 ** module chunks = 0
 **/